import * as React from 'react'

import { Button } from '@factorialco/deprecated-design-system'
import moment from 'moment'

import { observer } from 'mobx-react'

import Modal from 'modules/core/components/Modal'
import { useLazyRef } from 'modules/core/hooks/useLazyRef'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'
import legalEntitiesCollection from 'modules/core/store/collections/legalEntities'

import useCreateManualIncidence from 'modules/payroll_bundle/hooks/useCreateManualIncidence'
import ManualIncidenceForm from 'modules/payroll_bundle/pages/IncidencesPage/components/_ManualIncidenceModal/_Form'
import Form from 'modules/payroll_bundle/pages/IncidencesPage/utils/manualIncidenceForm'

interface Props {
  onClose: () => void
}

const New = ({ onClose }: Props) => {
  const form = useLazyRef(
    () =>
      new Form({
        legal_entity_id: legalEntitiesCollection.models[0]?.attributes.id,
        status: 'to-do',
        effective_on: moment().format('YYYY-MM-DD'),
      })
  ).current

  const isValid =
    !!form.get('description').value &&
    !!form.get('subject').value &&
    !!form.get('employee_id').value
  const { loading, create: onSubmit } = useCreateManualIncidence(form, onClose)
  const onSubmitWrapper = () => {
    onSubmit()
    track(trackingEvents.payroll.createManualIncidenceSubmit, {
      subject: form.get('subject').value,
      description: form.get('description').value,
      employee: !!form.get('employee_id').value,
    })
  }

  return (
    <Modal
      illustration="list-document"
      title={i18n.t('bookkeepers.incidence.manual.form.title')}
      description={i18n.t('bookkeepers.incidence.manual.form.description')}
      onClose={onClose}
      onSubmit={onSubmitWrapper}
      disableFocusTrap
      footer={
        <Button disabled={loading || !isValid} submit>
          {i18n.t('bookkeepers.incidence.manual.form.submit')}
        </Button>
      }
    >
      <ManualIncidenceForm form={form} />
    </Modal>
  )
}

export default observer(New)
